import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetExpectedDeliveryInformationForBasketQuery } from 'autogen/swagger/all/hooks';
import { SeeDeliveryOptionsV2 } from 'autogen/translation-keys/trans-website-basket-shipping';
import useExpectedDeliveryQuickView, {
    type ExpectedDeliveryParams
} from 'components/expecteddelivery/shared/hooks/useExpectedDeliveryQuickView';
import InlineButton from 'components/generic/InlineButton';

export default function DeliveryPreviewButton(): JSX.Element {
    const { t } = useTranslation();
    const [{ isOpen }, toggle] = useExpectedDeliveryQuickView();
    const { data } = useGetExpectedDeliveryInformationForBasketQuery(
        { zipCodeQuery: null },
        { enabled: isOpen, refetchOnWindowFocus: false }
    );
    const { zipCodeWithSource } = data || {};
    const { zipCode } = zipCodeWithSource || {};

    useEffect(() => {
        if (zipCode) {
            toggle(({ isOpen, params }) => ({ isOpen, params: { ...params, zipCode } as ExpectedDeliveryParams }));
        }
    }, [zipCode]);

    return (
        <InlineButton
            size="M"
            type="button"
            onClick={() => {
                toggle({ isOpen: true, params: { type: 'basket', zipCode } });
            }}
        >
            {t(SeeDeliveryOptionsV2)}
        </InlineButton>
    );
}
